import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';
import { TranslocoPipe } from '@jsverse/transloco';

import { ArcFormControl } from '~core/utils/arc-form-control';
import { CheckboxComponent } from '../../../form/checkbox/checkbox.component';
import { InputComponent } from '../../../form/input/input.component';

@Component({
    selector: 'arc-save-filter-dialog',
    templateUrl: './save-filter-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    imports: [
        ReactiveFormsModule,
        MatDialogTitle,
        CdkScrollable,
        MatDialogContent,
        InputComponent,
        CheckboxComponent,
        MatDialogActions,
        MatButton,
        MatDialogClose,
        TranslocoPipe
    ]
})
export class SaveFilterDialogComponent {
    readonly form = new FormGroup({
        isDefaultFilter: new ArcFormControl<boolean>(false),
        name: new ArcFormControl('', [Validators.required, Validators.maxLength(30)])
    });

    private readonly dialogRef = inject(MatDialogRef);

    constructor() {
        this.form.controls.isDefaultFilter.valueChanges.subscribe(value => {
            if (value) {
                this.form.controls.name.disable();
            } else {
                this.form.controls.name.enable();
            }
        });
    }

    save(): void {
        this.form.updateValueAndValidity();
        if (this.form.invalid) {
            return;
        }

        const name = this.form.value.name?.trim();
        const isDefaultFilter = this.form.value.isDefaultFilter;

        if (!name && !isDefaultFilter) {
            this.form.patchValue({ name: '' });
            this.form.updateValueAndValidity();
            return;
        }

        this.dialogRef.close({ name, isDefaultFilter });
    }
}
